import _styled2 from "@emotion/styled";
export var styled = _styled2;
export default styled;